import React from "react";
import { useLang } from "../../i18n";

const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee.items");
  const row = [...items, ...items, ...items];
  return (
    <section data-testid="marquee" className="bg-primary py-5 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="text-primary-foreground text-sm md:text-base uppercase tracking-[0.35em] font-medium px-10">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-secondary flex-shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
